import { render, staticRenderFns } from "./HomeworkAnswersWidget.vue?vue&type=template&id=13f74afc"
import script from "./HomeworkAnswersWidget.vue?vue&type=script&lang=js"
export * from "./HomeworkAnswersWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f74afc')) {
      api.createRecord('13f74afc', component.options)
    } else {
      api.reload('13f74afc', component.options)
    }
    module.hot.accept("./HomeworkAnswersWidget.vue?vue&type=template&id=13f74afc", function () {
      api.rerender('13f74afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/HomeworkAnswersWidget.vue"
export default component.exports